import { Box, Typography } from "@mui/material";
import BaseButton from "./BaseButton";
import RopTable, { TableItem, TableRowType } from "./RopTable/RopTable";
import { useContext } from "react";
import { MainContext } from "../context/MainContextProvider";
import AddIcon from "@mui/icons-material/Add";

export type ListScreenProps = {
  title?: string;
  buttonTilte?: string;
  onClick?: () => void;
  hover?: boolean;
  itemsHeaders?: TableItem[];
  itemRows?: TableRowType[];
  isLoading?: boolean;
  itemsAmount?: number;
  rowsPerPage?: number;
  page?: number;
  setPage?: (page: number) => void;
  setRowsPerPage?: (rowsPerPage: number) => void;
  search?: string;
  setSearch?: (search: string) => void;
  marginTopTable?: string;
  tableHeight?: string;
  maxHeigth?: number | string;
  bodyHeighTable?: number | string;
  headerRightComponent?: React.ReactNode;
};

export default function ListScreen(props: ListScreenProps) {
  const { userIsAdm } = useContext(MainContext);
  // const { userIsAdm, bodyHeight } = useContext(MainContext);

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        // height: bodyHeight,
        marginTop: "10px",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        style={{
          width: "90%",
          display: "flex",
          justifyContent: props.headerRightComponent ? "space-between" : "start",
          alignItems: "center",
          marginTop: props.marginTopTable ?? "20px",
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: "400", paddingTop: "15px", paddingBottom: "15px" }}
        >
          {props.title}
        </Typography>
        {props.headerRightComponent && <Box>{props.headerRightComponent}</Box>}
      </Box>
      <RopTable
        itemsAmount={props.itemsAmount}
        page={props.page}
        rowsPerPage={props.rowsPerPage}
        setPage={props.setPage}
        setRowsPerPage={props.setRowsPerPage}
        search={props.search}
        setSearch={props.setSearch}
        hover={props.hover}
        isLoading={props.isLoading}
        itemsHeaders={props.itemsHeaders}
        itemRows={props.itemRows}
        maxHeigth={props.maxHeigth}
      />

      {userIsAdm && props.buttonTilte && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: { md: "flex-end", xs: "center" },
            marginBottom: "10px",
            marginTop: "10px",
            flexDirection: "column",
            paddingRight: { md: "15px", xs: "0px" },
          }}
        >
          <BaseButton
            width={200}
            startIcon={<AddIcon />}
            title={props.buttonTilte}
            onClick={props.onClick}
          />
        </Box>
      )}
    </Box>
  );
}
